export default "__VITE_ASSET__CFwPwx3___"